import React, { useEffect, useState } from 'react';
import UbicacionEnMapa from '../mapa/UbicacionEnMapa';
import CreatableSelect from 'react-select/creatable';
import { Label, NextBtn, buildSelectStyles } from './ServicioUI';
import DateInput from '../ui/DateInput';

import { filtroMultiTermino } from '../../utils/busqueda';
function InfoCard({ children }) {
    return (
        <div className="rounded-xl p-3 bg-chip border border-black/10 dark:border-white/10">
            {children}
        </div>
    );
}

// Tarifa mensual por volumen (Modo Agua…): sus trabajos van sin precio al cierre del mes
const esMensual = (c) => { if (c?.tieneTarifa) return true; const t = String(c?.tarifaVolumen || '').trim(); return !!t && t !== '[]'; };

export default function PasoCliente({ hook, onNext, selectStyles, onCargaPorSerie = null, onPedidoEmpresa = null }) {
    const {
        db, clienteId, setClienteId,
        itemActual, setItemActual,
        onClienteSeleccionado,
        setNombreClientePrellenado, setModalClienteAbierto,
        setNombreSedePrellenado, setModalSedeAbierto,
        modoCliente: modo, setModoCliente: setModo,
        nombreLibre, setNombreLibre,
        telefonoLibre, setTelefonoLibre,
        dirLibre, setDirLibre, setPuntoLibre,
    } = hook;

    useEffect(() => {
        if (clienteId && modo === 'nuevo') setModo('registrado');
    }, [clienteId]);

    const clienteObj   = db.clientes?.find(c => c.id?.toString() === clienteId);
    // Cliente que se cobra por mes (29-oct-2026): lo primero es cargar el pedido igual que la empresa;
    // el trabajo con precio queda como excepción ("Presupuesto aparte")
    const [aparte, setAparte] = useState(false);
    useEffect(() => { setAparte(false); }, [clienteId]);
    const mensual = !!(clienteObj && onCargaPorSerie && esMensual(clienteObj));
    const soloOpciones = mensual && !aparte;
    const sedesCliente = db.sedes?.filter(s => s.cliente?.id?.toString() === clienteId) || [];

    const puedeAvanzar = modo === 'registrado'
        ? !!clienteId
        : nombreLibre.trim().length >= 2 && dirLibre.calle.trim().length >= 2 && dirLibre.localidad.trim().length >= 2;

    const handleNext = () => {
        onNext();
    };

    return (
        <div className="flex flex-col gap-4 px-5 pb-6">

            {/* ── Selector cliente ──────────────────────────────────────── */}
            {modo === 'registrado' ? (
                <div className="flex flex-col gap-3">
                    <div>
                        <Label>Cliente</Label>
                        <CreatableSelect filterOption={filtroMultiTermino}
                            styles={selectStyles}
                            menuPosition="fixed"
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            options={db.clientes?.map(c => ({ value: c.id.toString(), label: c.nombre }))}
                            value={clienteObj ? { value: clienteObj.id.toString(), label: clienteObj.nombre } : null}
                            onChange={s => {
                                if (s?.__isNew__) { setNombreClientePrellenado(s.label); setModalClienteAbierto(true); }
                                else onClienteSeleccionado(s?.value);
                            }}
                            onCreateOption={val => { setNombreClientePrellenado(val); setModalClienteAbierto(true); }}
                            placeholder="Escribí el nombre..."
                            isClearable
                            autoFocus
                        />
                    </div>

                    {/* 1-nov-2026: cada opción con una línea de para qué es; elegido "Presupuesto aparte", las otras
                        dos se esconden y queda un aviso con "Cambiar" (antes seguían a la vista y no se sabía en qué modo estabas) */}
                    {mensual && !aparte && (
                        <div className="rounded-xl p-3 bg-[var(--warning-bg)] border border-[#D48800]/30 space-y-2.5">
                            <p className="text-caption font-bold text-[var(--warning-tx)]">
                                {clienteObj.nombre} se cobra por mes: va por Pedido de empresa.
                            </p>
                            {onPedidoEmpresa ? (
                                <button type="button" onClick={() => onPedidoEmpresa({ id: clienteObj.id, nombre: clienteObj.nombre })}
                                    className="w-full h-12 rounded-xl bg-[#C9341F] text-white text-body font-black active:scale-95">Ir al pedido de {clienteObj.nombre}</button>
                            ) : (
                                <button type="button" onClick={() => onCargaPorSerie({ id: clienteObj.id, nombre: clienteObj.nombre })}
                                    className="w-full h-12 rounded-xl bg-[#C9341F] text-white text-body font-black active:scale-95">Cargar por N/S</button>
                            )}
                            <div className="text-center">
                                <button type="button" onClick={() => setAparte(true)} className="text-caption font-bold text-muted underline underline-offset-2">
                                    Presupuesto aparte (con precio)
                                </button>
                                <p className="text-caption text-muted">Fuera del abono, a aprobar</p>
                            </div>
                        </div>
                    )}
                    {mensual && aparte && (
                        <div className="flex items-center gap-2 rounded-xl px-3 py-2.5 bg-chip border border-black/10 dark:border-white/10">
                            <p className="flex-1 text-caption font-bold text-ink">Presupuesto aparte · con precio, fuera del abono</p>
                            <button type="button" onClick={() => setAparte(false)} className="text-caption font-black text-brand-red">Cambiar</button>
                        </div>
                    )}

                    {clienteObj && !soloOpciones && (
                        <>
                            <InfoCard>
                                <div className="grid grid-cols-2 gap-2">
                                    {clienteObj.telefono && (
                                        <div>
                                            <p className="text-label font-bold uppercase text-muted">Teléfono</p>
                                            <p className="text-body font-bold text-ink">{clienteObj.telefono}</p>
                                        </div>
                                    )}
                                    {clienteObj.localidad && (
                                        <div>
                                            <p className="text-label font-bold uppercase text-muted">Localidad</p>
                                            <p className="text-body font-bold text-ink">{clienteObj.localidad}</p>
                                        </div>
                                    )}
                                </div>
                            </InfoCard>

                            {sedesCliente.length === 1 ? (
                                <div>
                                    <Label>Sede / Domicilio</Label>
                                    <div className="flex items-center gap-2 px-3.5 py-2.5 rounded-xl bg-chip border border-black/10 dark:border-white/10">
                                        <span className="text-body font-bold text-ink flex-1 truncate">{sedesCliente[0].nombreSede}</span>
                                        <span className="text-label font-black text-[#1F9D55]">✓ Auto</span>
                                    </div>
                                </div>
                            ) : sedesCliente.length === 0 ? (
                                <div>
                                    <Label>Sede / Domicilio (opcional)</Label>
                                    <button type="button" onClick={() => setModalSedeAbierto(true)}
                                        className="w-full px-3.5 py-2.5 rounded-xl text-label font-bold text-muted border border-dashed border-muted/40 bg-transparent active:scale-95 transition-all">
                                        + Crear sede para este cliente
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    <Label>Sede / Domicilio</Label>
                                    <CreatableSelect filterOption={filtroMultiTermino}
                                        styles={selectStyles}
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                        menuPortalTarget={document.body}
                                        options={sedesCliente.map(s => ({ value: s.id.toString(), label: s.nombreSede }))}
                                        value={sedesCliente.find(s => s.id === itemActual.sedeId)
                                            ? { label: sedesCliente.find(s => s.id === itemActual.sedeId).nombreSede }
                                            : null}
                                        onChange={s => {
                                            if (s?.__isNew__) { setNombreSedePrellenado(s.label); setModalSedeAbierto(true); }
                                            else setItemActual({ ...itemActual, sedeId: parseInt(s?.value), sedeNombre: s?.label });
                                        }}
                                        onCreateOption={val => { setNombreSedePrellenado(val); setModalSedeAbierto(true); }}
                                        placeholder="Elegí o creá..."
                                        isClearable
                                    />
                                </div>
                            )}
                        </>
                    )}

                    {/* Link para cliente nuevo rápido */}
                    <button onClick={() => { setModo('nuevo'); setClienteId(null); }}
                        className="text-caption font-bold text-muted active:scale-95 transition-all self-start">
                        ¿Cliente nuevo? <span className="text-brand-red">Alta rápida</span>
                    </button>
                </div>
            ) : (
                <div className="flex flex-col gap-3">
                    <div>
                        <Label>Nombre del cliente *</Label>
                        <input
                            type="text"
                            value={nombreLibre}
                            autoFocus
                            onChange={e => setNombreLibre(e.target.value)}
                            placeholder="Ej: Juan García, Empresa SA..."
                            className="w-full block px-3.5 py-2.5 rounded-xl text-body font-medium outline-none bg-chip text-ink border border-black/10 dark:border-white/10 placeholder-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] focus:ring-2 focus:ring-[#D13A28]/20 transition-all"
                        />
                    </div>

                    <div>
                        <Label>Teléfono</Label>
                        <input
                            type="tel"
                            value={telefonoLibre}
                            onChange={e => setTelefonoLibre(e.target.value)}
                            placeholder="Ej: 1112345678"
                            className="w-full block px-3.5 py-2.5 rounded-xl text-body font-medium outline-none bg-chip text-ink border border-black/10 dark:border-white/10 placeholder-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] focus:ring-2 focus:ring-[#D13A28]/20 transition-all"
                        />
                    </div>

                    {/* Dirección del cliente */}
                    <div className="rounded-xl p-3 bg-chip border border-black/10 dark:border-white/10 space-y-2.5">
                        <p className="text-label font-black text-muted uppercase tracking-wider">Dirección</p>
                        <div className="grid grid-cols-[1fr_80px] gap-2">
                            <div>
                                <label className="text-label font-bold text-muted uppercase block mb-0.5">Calle *</label>
                                <input value={dirLibre.calle} onChange={e => setDirLibre(p => ({ ...p, calle: e.target.value }))}
                                    placeholder="Av. Rivadavia" className="w-full px-3 py-2 rounded-lg text-body font-medium outline-none bg-card text-ink border border-black/[0.06] dark:border-white/[0.06] placeholder:text-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] transition-all" />
                            </div>
                            <div>
                                <label className="text-label font-bold text-muted uppercase block mb-0.5">Nro</label>
                                <input value={dirLibre.numero} onChange={e => setDirLibre(p => ({ ...p, numero: e.target.value }))}
                                    placeholder="5000" className="w-full px-3 py-2 rounded-lg text-body font-medium outline-none bg-card text-ink border border-black/[0.06] dark:border-white/[0.06] placeholder:text-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] transition-all" />
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                            <div>
                                <label className="text-label font-bold text-muted uppercase block mb-0.5">Piso</label>
                                <input value={dirLibre.piso} onChange={e => setDirLibre(p => ({ ...p, piso: e.target.value }))}
                                    placeholder="3" className="w-full px-3 py-2 rounded-lg text-body font-medium outline-none bg-card text-ink border border-black/[0.06] dark:border-white/[0.06] placeholder:text-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] transition-all" />
                            </div>
                            <div>
                                <label className="text-label font-bold text-muted uppercase block mb-0.5">Depto</label>
                                <input value={dirLibre.depto} onChange={e => setDirLibre(p => ({ ...p, depto: e.target.value }))}
                                    placeholder="B" className="w-full px-3 py-2 rounded-lg text-body font-medium outline-none bg-card text-ink border border-black/[0.06] dark:border-white/[0.06] placeholder:text-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] transition-all" />
                            </div>
                        </div>
                        <div>
                            <label className="text-label font-bold text-muted uppercase block mb-0.5">Localidad / Barrio *</label>
                            <input value={dirLibre.localidad} onChange={e => setDirLibre(p => ({ ...p, localidad: e.target.value }))}
                                placeholder="Caballito, CABA" className="w-full px-3 py-2 rounded-lg text-body font-medium outline-none bg-card text-ink border border-black/[0.06] dark:border-white/[0.06] placeholder:text-muted focus:border-[#D13A28] dark:focus:border-[#E8422F] transition-all" />
                        </div>
                        {/* Mapa en vivo: se ve dónde cae y se corrige tocando el lugar real (13-oct-2026) */}
                        <UbicacionEnMapa direccion={[dirLibre.calle, dirLibre.numero].filter(Boolean).join(' ') + (dirLibre.localidad ? `, ${dirLibre.localidad}` : '')}
                            onCambio={setPuntoLibre}
                            onDireccion={d => setDirLibre(p => ({ ...p, calle: d.calle || p.calle, numero: d.numero, localidad: d.localidad || p.localidad }))} />
                    </div>

                    <button onClick={() => setModo('registrado')}
                        className="text-caption font-bold text-muted active:scale-95 transition-all self-start">
                        ¿Ya existe? <span className="text-brand-red">Buscar en lista</span>
                    </button>
                </div>
            )}

            {!soloOpciones && (
                <NextBtn onClick={handleNext} disabled={!puedeAvanzar}>
                    Siguiente — Equipos
                </NextBtn>
            )}
        </div>
    );
}
